// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: fixed !important;
  width: 100%;
  height: 100%;
  top: 85px;
  margin-bottom: 85px;
}

.activity-header {
  height: 40px !important;
  width: 100%;
  line-height: 75px;
  box-shadow: inset 1px 0 5px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  z-index: 114;
  position: fixed;
  padding-right: 6%;
}

.pad {
  position: absolute;
  display: inline;
  top: 0;
  left: 0;
  z-index: 115;
  touch-action: none;
}

.pad-container {
  position: fixed;
  overflow: inherit !important;
  z-index: 113;
  text-align: center;
  width: 96%;
  border: 1px solid 128, 128, 128, 0.2;
  border-top: none;
  border-radius: 0px 0px 10px 10px;
  background: rgba(255, 255, 255, 0.44);
  top: 124.5px;
}

.text-box-wrapper {
  position: relative;
  height: calc(100% - 30px);
  width: 100%;
}
.text-box-wrapper .target {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.pullout-handle {
  z-index: 20;
  width: 100%;
  left: 0;
  height: 30px;
  bottom: -3px;
  background: url('transparencyhandle.9ac4d0ebf7efb16a.png') no-repeat center bottom;
}

::ng-deep .tool-button {
  font-size: 1.5rem;
  text-align: center;
  display: block;
  height: 100%;
  margin-left: 10px;
  float: left;
  color: #888888;
}
::ng-deep .tool-button.active {
  color: black;
}
::ng-deep .tool-button .color-indicator {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 0.5em;
}

#draw-button-circle, .draw-button-circle {
  font-size: 1.5rem;
  text-align: center;
  display: block;
  height: 100%;
  margin-left: 10px;
  float: left;
  color: rgba(255, 255, 255, 0.5);
}
#draw-button-circle.active, .draw-button-circle.active {
  box-shadow: inset 0px 1px 4px #4D4D4D;
  margin-top: 1px;
}

#draw-button-border {
  font-size: 2rem;
  text-align: center;
  display: block;
  height: 80%;
  width: 75px;
  border-right: 1px solid #c8c8c8;
  float: left;
}

.blue {
  color: rgba(135, 170, 255, 0.8) !important;
}

.pink {
  color: rgba(255, 0, 174, 0.3803921569) !important;
}

.green {
  color: rgba(30, 255, 0, 0.3411764706) !important;
}

.black {
  color: rgba(0, 0, 0, 0.5215686275) !important;
}`, "",{"version":3,"sources":["webpack://./src/activities/activity-header/activity-header.scss"],"names":[],"mappings":"AAKA;EAEE,0BAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;AALF;;AAOA;EAEE,uBAAA;EACA,WAAA;EACA,iBAAA;EAEA,kDAAA;EAEA,aAAA;EACA,uBAAA;EAEA,YAAA;EACA,eAAA;EACA,iBAAA;AAPF;;AASA;EAKE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACD,kBAAA;AAVD;;AAYA;EACE,eAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EAGA,oCAAA;EACA,gBAAA;EACA,gCAAA;EACA,qCAAA;EACA,YAAA;AAXF;;AAeA;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;AAZF;AAcE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AAZJ;;AAgBA;EACE,WAAA;EACD,WAAA;EACC,OAAA;EACD,YAAA;EAEA,YAAA;EACA,kFAAA;AAdD;;AAkBA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;AAfF;AAiBE;EACE,YAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AAhBJ;;AAqBA;EAEE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,+BAAA;AAnBF;AAqBE;EACE,qCAAA;EACA,eAAA;AAnBJ;;AAwBA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,+BAAA;EACA,WAAA;AArBF;;AAwBA;EACE,0CAAA;AArBF;;AAuBA;EACE,iDAAA;AApBF;;AAsBA;EACE,gDAAA;AAnBF;;AAqBA;EACE,6CAAA;AAlBF","sourcesContent":["// @import \"../../styles.scss\";\n// @import \"../../component_variable.scss\";\n\n// $background-color: #e6e6e6;\n\n.wrapper {\n  // z-index: 1001;\n  position: fixed !important;\n  width: 100%;\n  height: 100%;\n  top: 85px;\n  margin-bottom: 85px;\n}\n.activity-header {\n  // background-color: $background-color;\n  height: 40px !important;\n  width: 100%;\n  line-height: 75px;\n  -webkit-box-shadow:inset 1px 0 5px 3px rgba(0,0,0,0.1);\n  box-shadow:inset 1px 0 5px 3px rgba(0,0,0,0.1);\n\n  display: flex;\n  justify-content: center;\n\n  z-index: 114;\n  position: fixed;\n  padding-right: 6%;\n}\n.pad {\n\n  // height: calc(100% - 60px);\n\n  // width: 80%;\n  position: absolute;\n  display: inline;\n  top: 0;\n  left: 0;\n  z-index: 115;\n\ttouch-action: none;\n}\n.pad-container {\n  position: fixed;\n  overflow: inherit !important;\n  z-index: 113;\n  text-align: center;\n  width: 96%;\n  // height: calc(85% - 45px);\n  // left: 20px;\n  border: 1px solid (128,128, 128, 0.2);\n  border-top: none;\n  border-radius: 0px 0px 10px 10px;\n  background: rgba(255,255,255,0.44);\n  top: 124.5px;\n\n}\n\n.text-box-wrapper {\n  position: relative;\n  height: calc(100% - 30px);\n  width: 100%;\n\n  .target {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n  }\n}\n\n.pullout-handle {\n  z-index: 20;\n\twidth: 100%;\n  left: 0;\n\theight: 30px;\n\t// position: absolute;\n\tbottom: -3px;\n\tbackground: url('../../assets/img/transparencyhandle.png') no-repeat center bottom;\n}\n\n::ng-deep {\n.tool-button {\n  font-size: 1.5rem;\n  text-align: center;\n  display: block;\n  height: 100%;\n  margin-left: 10px;\n  float: left;\n  color: #888888;\n\n  &.active {\n    color: black;\n  }\n\n  .color-indicator {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    font-size: .5em;\n  }\n}\n\n}\n#draw-button-circle, .draw-button-circle {\n\n  font-size:1.5rem;\n  text-align: center;\n  display: block;\n  height: 100%;\n  margin-left: 10px;\n  float: left;\n  color: rgba(255, 255, 255, 0.5);\n\n  &.active {\n    box-shadow: inset 0px 1px 4px #4D4D4D;\n    margin-top: 1px;\n  }\n\n}\n\n#draw-button-border {\n  font-size: 2rem;\n  text-align: center;\n  display: block;\n  height: 80%;\n  width: 75px;\n  border-right: 1px solid #c8c8c8;\n  float: left;\n\n}\n.blue {\n  color: #87aaffcc !important;\n}\n.pink {\n  color: #ff00ae61 !important;\n}\n.green {\n  color: #1eff0057 !important;\n}\n.black {\n  color: #00000085 !important;\n}\n// .active-indicator{\n//   width: 100%;\n//   height: 5px;\n//   position:relative;\n//   background-color: $primary-dark;\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
